import { IApplicationState } from '../../types/redux';

export function selectCalculateResultModalOpen(state: IApplicationState): boolean {
  return state.calculateResultModal.isOpen;
}
